import { Skeleton } from '@/components/ui/skeleton';
import React from 'react';
import { View } from 'react-native';

/**
 * Loading placeholder for {@link RestaurantCard}. Mirrors its `mr-4 w-64`
 * footprint and 128px image so a loading rail reserves the same height the
 * real cards will occupy — no reflow when data arrives.
 */
const RestaurantCardSkeleton = React.memo(() => (
  <View className="mr-4 w-64">
    <View className="rounded-xl overflow-hidden bg-surface">
      <Skeleton width="100%" height={128} radius={0} />
      <View className="p-3">
        <Skeleton width="75%" height={15} radius={4} style={{ marginBottom: 8 }} />
        <Skeleton width="55%" height={12} radius={4} style={{ marginBottom: 10 }} />
        <Skeleton width="40%" height={12} radius={4} />
      </View>
    </View>
  </View>
));

RestaurantCardSkeleton.displayName = 'RestaurantCardSkeleton';

export default RestaurantCardSkeleton;
